import React, { Component } from 'react';
import BaseLayout from './../../templates/base'
import PermissionEditForm from './../../elements/permissions/form';
import Loading from "../../elements/loading";
import PermissionsAdd from './../../elements/permissions/widget/permissions_add';

class PermissionsForm extends Component {
	render() {
		const { permissions } = this.props;
		return (
			permissions.isFetching ? <Loading/>:<PermissionEditForm {...this.props}/>
		)
	}

	componentWillMount() {
		this.props.permissionEdit(this.props.match.params.id);
	}
}

//export default BaseLayout(PermissionsForm, {title: `Editar Permiso`, subnav: {icon: 'fa-user-secret', name: 'Administración', actions: {url: '/permisos/crear', name: 'Agregar Permiso'}}});
export default BaseLayout(PermissionsForm, {
	title: 'Editar Permiso',
	subnav: {
		icon: 'fa-user-secret',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <PermissionsAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/permissions/edit.jsx